import { InvestmentGoalResponse } from "../../../services";
import { isPricedValuation } from "../../../services/valuation";

export const settledAtOf = (goal: InvestmentGoalResponse) =>
  goal.reachedAt ?? goal.archivedAt;

export const isSettledInvestmentGoal = (goal: InvestmentGoalResponse) =>
  settledAtOf(goal) !== null;

// A goal fed by a holdings-ledger account inherits that account's pending quote.
export const hasCurrentValuation = ({ projection }: InvestmentGoalResponse) =>
  projection.progressPercent !== null &&
  isPricedValuation({
    value: projection.currentAmount,
    valuation: projection.valuation,
  });
